var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18pt",
    height: "18pt",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 49,
    y1: 94.45,
    x2: 49,
    y2: 11.6498,
    gradientTransform: "matrix(0.183673,0,0,-0.183673,0,18.734694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,93.72549%,81.960784%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,67.45098%,91.764706%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 16.457031 15.648438 L 13.222656 12.417969 C 14.214844 11.242188 14.824219 9.734375 14.824219 8.082031 C 14.824219 4.40625 11.808594 1.394531 8.101562 1.394531 C 4.390625 1.394531 1.378906 4.40625 1.378906 8.082031 C 1.378906 11.753906 4.390625 14.785156 8.101562 14.785156 C 9.753906 14.785156 11.257812 14.179688 12.433594 13.207031 L 15.6875 16.4375 C 15.796875 16.550781 15.941406 16.605469 16.070312 16.605469 C 16.21875 16.605469 16.347656 16.550781 16.457031 16.4375 C 16.675781 16.199219 16.675781 15.851562 16.457031 15.648438 Z M 2.480469 8.082031 C 2.480469 4.996094 4.996094 2.480469 8.101562 2.480469 C 11.203125 2.480469 13.71875 4.996094 13.71875 8.082031 C 13.71875 9.625 13.097656 11.019531 12.085938 12.03125 L 12.050781 12.066406 C 11.039062 13.058594 9.644531 13.683594 8.101562 13.683594 C 4.996094 13.683594 2.480469 11.1875 2.480469 8.082031 Z M 2.480469 8.082031 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c1ffdfd9142e894afcf5d0742483f728.svg";
export { ForwardRef as ReactComponent };